export default __webpack_public_path__ + "static/media/wd_logo_w.ea076a1b.svg";